<template>
  <v-container fluid class="down-top-padding">
    <div id="itemsPage" class="page">
      <div class="page__header ">
        <Toolbar
          :showFiltersPanel="showFiltersPanel"
          @showFiltersPanelChanged="handleShowFiltersPanelChanged"
          @toggleDialog="toggleDialog"
        />
      </div>
      <div class="page__body pa-4">
        <div class="mb-4" v-show="showFiltersPanel">
          <v-row class="my-0">
            <v-col md="12">
              <Filters @filtersChanged="handleFiltersChanged" />
            </v-col>
          </v-row>
        </div>

        <v-dialog v-model="dialog" persistent scrollable max-width="1200px">
          <Form
            v-if="dialog"
            @formSubmit="handleFormSubmit"
            :toggleDialog="toggleDialog"
            :isSubmittingForm="isSubmittingForm"
            :selectedItem="selectedItem"
            :colors="colors"
            :units="units"
            :sizes="sizes"
          />
        </v-dialog>
        <List
          :page="page"
          :items="items"
          :totalCount="totalCount"
          :isFetchingItems="isFetchingItems"
          :itemsPerPage="itemsPerPage"
          @editItem="handleEditItem"
          @deleteItem="handleDeleteItem"
          @optionsChanged="handleOptionsChanged"
          @changeStatus="handleChangeStatus"
        />
      </div>
      <ConfirmationPopup
        id="item-delete-modal"
        v-if="itemToDelete"
        title="Məhsulun silinməsi"
        :dialog="confirmationDialog"
        :loading="isDeletingItem"
        @confirm="handleDeleteConfirmation"
        @cancel="handleDeleteCancellation"
      >
        <span class="font-weight-bold">
          {{ itemToDelete.name }}
        </span>
        məhsulunu silmək istədiyinizə əminsiniz?
      </ConfirmationPopup>
    </div>
  </v-container>
</template>

<script>
import API from "@/services";
import ConfirmationPopup from "@/shared/Common/ConfirmationPopup.vue";
import List from "./components/List/index.vue";
import Form from "./components/Form/index.vue";
import Toolbar from "./components/Toolbar/index.vue";
import Filters from "./components/Toolbar/components/Filters.vue";
import bus from "../../../event-bus";

export default {
  components: {
    List,
    Form,
    Toolbar,
    ConfirmationPopup,
    Filters,
  },
  data() {
    return {
      dialog: false,
      confirmationDialog: false,
      selectedItem: null,
      itemToDelete: null,
      page: 1,
      isFetchingItems: false,
      isSubmittingForm: false,
      isDeletingItem: false,
      totalCount: 0,
      itemsPerPage: 10,
      items: [],
      filters: {},
      showFiltersPanel: false,
      colors: [],
      units: [],
      sizes: [],
    };
  },
  async created() {
    this.colors = await API.fetchAllColors();
    this.units = await API.fetchAllUnits();
    this.sizes = await API.fetchAllSizes();
    this.fetchItems();
  },
  methods: {
    fetchItems() {
      this.isFetchingItems = true;
      API.fetchProducts({
        limit: this.itemsPerPage,
        offset: (this.page - 1) * this.itemsPerPage,
        ...this.filters,
      })
        .then((response) => {
          this.items = response.items;
          this.totalCount = response.totalCount;
        })
        .catch(() => {
          bus.$emit("notificationMessage", {
            color: "error",
            text: "Məhsulların siyahısını əldə etmək mümkün olmadı.",
          });
        })
        .finally(() => {
          this.isFetchingItems = false;
        });
    },
    handleFormSubmit(formData) {
      this.isSubmittingForm = true;
      const request = this.selectedItem
        ? API.updateProduct(this.selectedItem.id, formData)
        : API.insertProduct(formData);

      request
        .then(() => {
          this.toggleDialog();
          this.fetchItems();
        })
        .catch(() => {
          bus.$emit("notificationMessage", {
            color: "error",
            text: "Əməliyyatı aparmaq mümkün olmadı.",
          });
        })
        .finally(() => {
          this.isSubmittingForm = false;
        });
    },
    handleEditItem(item) {
      this.isFetchingItems = true;
      API.fetchProductById(item.id)
        .then((response) => {
          this.selectedItem = response;
          this.dialog = true;
        })
        .catch(() => {
          bus.$emit("notificationMessage", {
            color: "error",
            text: "Məlumatı əldə etmək mümkün olmadı.",
          });
        })
        .finally(() => {
          this.isFetchingItems = false;
        });
    },
    handleDeleteItem(item) {
      this.itemToDelete = item;
      this.confirmationDialog = true;
    },
    handleDeleteConfirmation() {
      this.isDeletingitem = true;
      API.deleteProduct(this.itemToDelete.id)
        .then(() => {
          this.confirmationDialog = false;
          this.itemToDelete = null;
          this.fetchItems();
        })
        .catch(() => {
          bus.$emit("notificationMessage", {
            color: "error",
            text: "Məhsulu silmək mümkün olmadı.",
          });
        })
        .finally(() => {
          this.isDeletingItem = false;
        });
    },
    handleDeleteCancellation() {
      this.confirmationDialog = false;
      this.itemToDelete = null;
    },
    handleFiltersChanged(filters) {
      if (JSON.stringify(filters) !== JSON.stringify(this.filters)) {
        this.page = 1;
        this.filters = { ...filters };
        this.fetchItems();
      }
    },
    handleChangeStatus(item) {
      this.isFetchingItems = true;

      API.changeProductStatus(item.id)
        .then(() => {
          this.fetchItems();
        })
        .catch(() => {
          bus.$emit("notificationMessage", {
            color: "error",
            text: "Məhsulun statusunu dəyişmək mümkün olmadı.",
          });
        });
    },
    toggleDialog() {
      this.dialog = !this.dialog;
      if (!this.dialog) {
        this.selectedItem = null;
      }
    },
    handleOptionsChanged(item) {
      if (this.page !== item.page || this.itemsPerPage !== item.itemsPerPage) {
        this.page = item.page;
        this.itemsPerPage = item.itemsPerPage;

        this.fetchItems();
      }
    },
    handleShowFiltersPanelChanged(item) {
      this.showFiltersPanel = item;
    },
  },
};
</script>
